import { FileSystemReadOnlyException } from '#filespace/types';
export class ReadOnlyFilePermissionsManager {
    delegate;
    constructor(delegate) {
        this.delegate = delegate;
    }
    listAccessPartialFrom(params) {
        return this.delegate.listAccessPartialFrom(params);
    }
    listAccessPaginated(params) {
        return this.delegate.listAccessPaginated(params);
    }
    listAccess(filter) {
        return this.delegate.listAccess(filter);
    }
    getPrincipalsAccess(principals) {
        return this.delegate.getPrincipalsAccess(principals);
    }
    stats() {
        return this.delegate.stats();
    }
    grantAccess(_principalId, _entryId, _permissions) {
        throw new FileSystemReadOnlyException('grantAccess is not available in read-only mode.');
    }
    revokeAccess(_principalId, _entryId) {
        throw new FileSystemReadOnlyException('revokeAccess is not available in read-only mode.');
    }
}
